import { Observable } from 'rxjs';
import {
  IBank,
  ICreatePayoutAccountPayload,
  IPaginatedResponse,
  IPayoutAccount,
  IResolveBankAccountPayload,
  IResolveResult,
  IUpdatePayoutAccountLabelPayload
} from '@pharvio/core/shared';

export abstract class PayoutAccountsDataService {
  abstract getAccounts(): Observable<IPaginatedResponse<IPayoutAccount>>;
  abstract createAccount(
    payload: ICreatePayoutAccountPayload
  ): Observable<IPayoutAccount>;
  abstract archiveAccount(id: string): Observable<void>;
  abstract updateLabel(
    id: string,
    payload: IUpdatePayoutAccountLabelPayload
  ): Observable<IPayoutAccount>;
  abstract getBanks(): Observable<IBank[]>;
  abstract resolveBankAccount(
    payload: IResolveBankAccountPayload
  ): Observable<IResolveResult>;
}
